import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import VisionMissionSection from './components/VisionMissionSection';
import ContactSection from './components/ContactSection';
import ProductsSection from './components/ProductsSection';
import ProductsPage from './pages/ProductsPage';
import WholesaleProductsPage from './pages/WholesaleProductsPage';
import RetailProductsPage from './pages/RetailProductsPage';
import TeaProductsPage from './pages/TeaProductsPage';
import TeaProductDetailPage from './pages/TeaProductDetailPage';
import WholesaleProductDetailPage from './pages/WholesaleProductDetailPage';
import RetailProductDetailPage from './pages/RetailProductDetailPage';

const fullscreenPageSx = {
  width: '100%',
  minHeight: '100vh',
  height: { xs: 'auto', md: '100vh' },
  overflowX: 'hidden',
  overflowY: { xs: 'auto', md: 'hidden' },
};

function HomePage() {
  return (
    <Box sx={fullscreenPageSx}>
      <Navbar />
      <HeroSection />
    </Box>
  );
}

function AboutPage() {
  return (
    <Box sx={fullscreenPageSx}>
      <Navbar />
      <AboutSection />
    </Box>
  );
}

function VisionPage() {
  return (
    <Box sx={fullscreenPageSx}>
      <Navbar />
      <VisionMissionSection />
    </Box>
  );
}

function ContactPage() {
  return (
    <Box sx={fullscreenPageSx}>
      <Navbar />
      <ContactSection />
    </Box>
  );
}

function ProductsSectionPage() {
  return (
    <Box sx={fullscreenPageSx}>
      <Navbar />
      <ProductsSection />
    </Box>
  );
}

function ProductsConnectorPage() {
  return (
    <Box sx={fullscreenPageSx}>
      <ProductsPage />
    </Box>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/vision" element={<VisionPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/products" element={<ProductsSectionPage />} />
        <Route path="/products/categories" element={<ProductsConnectorPage />} />
        <Route path="/products/wholesale" element={<WholesaleProductsPage />} />
        <Route path="/products/wholesale/:productId" element={<WholesaleProductDetailPage />} />
        <Route path="/products/retail" element={<RetailProductsPage />} />
        <Route path="/products/retail/:productId" element={<RetailProductDetailPage />} />
        <Route path="/products/tea" element={<TeaProductsPage />} />
        <Route path="/products/tea/:productId" element={<TeaProductDetailPage />} />
      </Routes>
    </Router>
  );
}

export default App;
